





































import { Component, Vue } from 'vue-property-decorator';
import { rolesModule, usersModule } from '@/store';
import IconTimes from '@/assets/icons/times.svg';
import { Form } from 'element-ui';
import UserForm from './UserForm.vue';

interface IForm {
  firstName?: string;
  surname?: string;
  phoneNumber?: string;
  email?: string;
  roleIds?: Array<number>;
  description?: string;
  password?: string;
}

@Component({
  name: 'users-create-window',
  components: { UserForm, IconTimes },
})
export default class UsersCreateWindow extends Vue {
  users: IForm[] = [];

  visible = false;

  updateForm<K extends keyof IForm>(
    propertyName: K,
    value: IForm[K],
    index: number,
  ) {
    this.users[index][propertyName] = value;
  }

  get rolesList() {
    return rolesModule.list;
  }

  open() {
    this.visible = true;
    this.users = [];
    this.createEmptyForm();
  }

  close() {
    this.visible = false;
  }

  createEmptyForm() {
    this.users.push({
      firstName: '',
      surname: '',
      phoneNumber: '',
      email: '',
      roleIds: [],
      password: '',
    });
  }

  async onSubmit() {
    const forms: Form[] = Array.isArray(this.$refs.forms)
      ? (this.$refs.forms as any).map((form: any) => form.$refs.form)
      : [];

    const ready = forms.every((form) => {
      let yes = false;
      form.validate((valid) => {
        yes = valid;
      });
      return yes;
    });

    if (ready) {
      const users = this.users.map(user => ({
        user: {
          firstName: user.firstName,
          surname: user.surname,
          phoneNumber: user.phoneNumber,
          email: user.email,
          description: user.description,
        },
        id: undefined,
        password: user.password,
        roleIds: user.roleIds,
      }));
      await usersModule.saveUsers(users);
      this.close();
    }
  }
}
